import React, { Component } from 'react'
import Select from 'components/Select'
import styled from 'styled-components'
import Arrow from './assets/ic-arrow-more.svg'

class SelectInput extends Component {
  changeHandler = (selected) => {
    this.props.onChange(selected.value)
  }

  render () {
    return (
      <Label>{this.props.label}
        <InnerSelect
          items={this.props.items}
          selected={this.props.selected}
          onChange={this.changeHandler}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
        />
        <ArrowIcon />
      </Label>
    )
  }
}

const Label = styled.label`
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  width: 100%;
  display: block;
  font-family: 'Nunito';
  color: #676767;
  font-family: Nunito;
  font-weight: 600;
  line-height: 14px;
  position: relative;
`

const InnerSelect = styled(Select)`
  width: 100%;
  max-width: 100%;
  height: 40px;
  box-sizing: border-box;
  margin-top: 8px;

  &:first-child > div:first-child {
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #dedede;
  }
`

const ArrowIcon = styled.div`
  position: absolute;
  background: url(${Arrow}) no-repeat;
  background-size: contain;
  width: 12px;
  height: 12px;
  top: 39px;
  right: 10px;
  transform: rotate(90deg);
`

export default SelectInput



// WEBPACK FOOTER //
// ./src/components/SelectInput/index.js